// extracted by mini-css-extract-plugin
export var divider = "_2t-0";
export var dividerText = "_2t-1";